module.exports = __webpack_public_path__ + "static/media/IllychReal.a187c35a.svg";